import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "circle-check, check radio, circle, checkbox, check, checkmark, confirm" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3ZM1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9ZM11.7249 6.54453C12.0455 6.80683 12.0928 7.27934 11.8305 7.59993L8.45547 11.7249C8.32129 11.8889 8.12399 11.9885 7.91236 11.9991C7.70073 12.0096 7.4945 11.9302 7.34467 11.7803L5.84467 10.2803C5.55178 9.98744 5.55178 9.51256 5.84467 9.21967C6.13756 8.92678 6.61244 8.92678 6.90533 9.21967L7.81932 10.1337L10.6695 6.65007C10.9318 6.32949 11.4043 6.28224 11.7249 6.54453Z",
    fill: "currentColor",
    "fill-opacity": "0.6157"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }